import React from 'react'
import { Navigate } from 'react-router-dom'
import { useCurrentPractice } from '../../../contexts/PracticeContext'
import { useCapitalAccess } from '../../../hooks/useCapitalAccess'

interface StripeCapitalGuardProps {
	children: React.ReactNode
}

const StripeCapitalGuard = ({ children }: StripeCapitalGuardProps) => {
	const { currentPracticeObject } = useCurrentPractice()
	const { canAccess } = useCapitalAccess()

	if (!Object.keys(currentPracticeObject).length) {
		return null
	}

	if (!canAccess) {
		return <Navigate to="/404" />
	}

	return <>{children}</>
}

export default StripeCapitalGuard
